export const DEFAULT_PAGE_SIZE = 20
export const DEFAULT_PAGE_NUMBER = 1
export const PAGE_SIZE_COMMON = 100
export const INFINITE_SCROLL_PAGE_SIZE = 100
